// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CheckboxListWithLabel from '../../../shared/components/checkbox-list-with-label';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import {FormattedMessage} from 'react-intl';
import {addCollectionLabels} from '../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../shared/services/hashmap';

const MaintenancePlanDealersCriteria = props => {

    const dealerSelectionMessage = props.selectedDealers.length ? 'DESELECT_ALL' : 'SELECT_ALL';

    return (

        <section className='maintenance-plan-dealers-criteria'>
            <CheckboxListWithLabel
                className='dealers-criteria'
                initialState={createHashMap(props.selectedDealers, 'account')}
                isRequired={true}
                label='DEALER_LOCATION'
                list={addCollectionLabels(props.selectedAccounts)}
                onChange={props.onHandleDealersSelectChange}
                uid='account'
            />
            <button
                className='toggle-all'
                onClick={props.onHandleSelectAllDealers}
                type='button'
            >
                <FormattedMessage id={dealerSelectionMessage}/>
            </button>
        </section>

    );

};

MaintenancePlanDealersCriteria.displayName = 'MaintenancePlanDealersCriteria';
MaintenancePlanDealersCriteria.propTypes = {
    onHandleDealersSelectChange: PropTypes.func.isRequired,
    onHandleSelectAllDealers: PropTypes.func.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default MaintenancePlanDealersCriteria;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/components/maintenance-plan-dealers-criteria.js